import { useEffect } from "react";
import { router } from "expo-router";
import { getPendingEnvironmentSwitch, setPendingEnvironmentSwitch, switchEnvironment } from "./environment-store";

/**
 * When the env screen navigates to /auth/switch-environment after the user
 * confirms a switch, the pending switch is consumed here to avoid running
 * clearAuth/setEnvironment while the env screen is still mounted (which can
 * cause an RN/Hermes crash).
 *
 * Once the switch settles (or if there is none), navigates to `/` so the
 * AuthProvider gate shows the Auth0 SignInScreen; the gate skips AUTH_SCREENS,
 * so staying on /auth/switch-environment would leave the user on a spinner.
 */
export function usePendingEnvironmentSwitch(): void {
  useEffect(() => {
    const pending = getPendingEnvironmentSwitch();
    if (!pending) {
      router.replace("/");
      return;
    }
    switchEnvironment(pending)
      .finally(() => {
        setPendingEnvironmentSwitch(null);
        router.replace("/");
      })
      .catch((err) => {
        console.error("[usePendingEnvironmentSwitch] Switch failed:", err);
      });
  }, []);
}
